<template>
	<el-dialog :visible.sync="is_visible" :width="'35%'" @close="close" title="SMS Template Form">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form @submit.prevent="submit" ref="updateStatusForm" v-loading="is_loading">
				<b-row>
					<b-col cols="12">
						<b-form-group label="SMS Type:">
							<el-select v-model="form.sms_type" placeholder="Select" required>
								<el-option :label="'No Selected'" :value="null"></el-option>
								<el-option v-for="([key, value]) in smsTypeList" :key="key" :label="value" :value="key">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<!-- FIELD STATUS -->
					<b-col cols="12">
						<b-form-group label="Title:">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true }" :vid="'title'">
								<b-form-input v-model="form.sms_title" type="text" required></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<!-- FIELD STATUS TYPE -->
					<b-col cols="12">
						<b-form-group label="Content:">
							<ValidationProvider v-slot="{ errors }" :rules="{ required: true, maxChars: true }" :vid="'content'">
								<b-form-textarea v-model="form.sms_content" placeholder="Enter sms content..." rows="3"
									max-rows="6"></b-form-textarea>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
								<small v-if="!errors[0]" class="text-muted">{{ charCount }} characters | {{ smsCount }} SMS</small>
							</ValidationProvider>
						</b-form-group>
					</b-col>
					<b-col cols="12">
						<b-form-group>
							<el-switch v-model="form.is_auto_send" active-color="#0BC196" :active-value="1"
								:inactive-value="0"></el-switch>
							<span class="ml-2"> Auto Send</span>
						</b-form-group>
					</b-col>
					<b-col cols="12" v-if="form.is_auto_send == 1">
						<b-form-group label="Resend Runtime:">
							<el-select v-model="form.resend_run" placeholder="Select" required>
								<el-option :label="'Not Selected'" :value="null"></el-option>
								<!-- <el-option :label="'Every Day'" value="EVERY_DAY"></el-option> -->
								<el-option :label="'After Due Date'" value="AFTER_DUE"></el-option>
								<el-option :label="'Before Due Date'" value="BEFORE_DUE"></el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col cols="12" v-if="form.is_auto_send == 1 && !_gHlp.isEmpty(form.resend_run)">
						<b-form-group label="Days:">
							<b-form-input v-model="form.resend_day" type="number" step="1"></b-form-input>
						</b-form-group>
					</b-col>
					<!-- <b-col cols="12">
                        <b-form-group label="Customer Sub Status:">
                            <el-select
                                v-model="form.customer_status_id"
                                value-key="status_id"
                                filterable
                                >
                                <el-option :label="'-- Please select sub status --'" :value="null"></el-option>
                                <el-option
                                v-for="status in customerSubStatusList"
                                :key="status.status_id"
                                :label="status.parent_status + ' - ' + status.status"
                                :value="status.status_id"
                                >
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col> -->
					<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
						<b-button variant="primary" class="w-100" @click="submit"> {{ _gHlp.isEmpty(form.sms_template_id) ? 'Save':'Update' }}</b-button>
					</b-col>
				</b-row>
			</b-form>
		</ValidationObserver>
	</el-dialog>
</template>
<script>
import { Select, Option, Checkbox, Dialog, Switch } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { extend } from 'vee-validate';
import { mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
	props: {
		customerSubStatusList: Array,
	},
	components: {
		ValidationObserver,
		ValidationProvider,
		[Switch.name]: Switch,
		[Dialog.name]: Dialog,
		[Select.name]: Select,
		[Option.name]: Option,
		[Checkbox.name]: Checkbox,
	},
	computed: {
		charCount() {
			return this.form.sms_content.length;
		},
		smsCount() {
			return Math.ceil(this.charCount / 160);
		},
		smsTypeList() {
			return Object.entries(_gConst.smsType)
		}
	},
	data() {
		return {
			is_visible: false,
			is_loading: false,
			form: {
				sms_type: null,
				customer_status_id: null,
				sms_title: '',
				sms_content: '',
				is_auto_send: 0,
				resend_run: null,
				resend_day: 0
			}
		}
	},
	created() {
		extend('maxChars', {
			validate: () => this.charCount <= 155,
			message: 'SMS Content should not exceed 155 characters',
		});
	},
	methods: {
		...mapActions(useMessagingStore, ['createSmsTemplate', 'updateSmsTemplate']),
		show(item) {
			if (!_gHlp.isEmpty(item)) {
				this.form = item
				this.form.is_auto_send = parseInt(item.is_auto_send)
			}
			this.is_visible = true
		},
		close() {
			this.is_visible = false
			this.is_loading = false
			this.form = {
				sms_type: null,
				customer_status_id: null,
				sms_title: '',
				sms_content: '',
				is_auto_send: 0,
				resend_run: null,
				resend_day: 0
			}
		},
		submit() {
			//CREATE
			this.is_loading = true;
			const formData = {
				sms_type: this.form.sms_type,
				customer_status_id: this.form.customer_status_id,
				sms_title: this.form.sms_title,
				sms_content: this.form.sms_content,
				is_auto_send: this.form.is_auto_send,
				resend_run: this.form.resend_run,
				resend_day: this.form.resend_day
			}
			if (!_gHlp.isEmpty(this.form.sms_template_id)) {
				this.updateSmsTemplate(this.form.sms_template_id,formData).then(resp => {
					_gNotif.notifySuccess('<b>SMS Template</b> - Successfully Updated.')
					this.is_loading = false;
					this.$emit('closeModal',true)
					this.close();
				}).catch(err => {
					_gNotif.notifySuccess('<b>SMS Template</b> - Failed to Update.')
					this.is_loading = false;
				})
			} else {
				this.createSmsTemplate(formData).then(resp => {
					_gNotif.notifySuccess('<b>SMS Template</b> - Successfully Created.')
					this.is_loading = false;
					this.$emit('closeModal',true)
					this.close();
				}).catch(err => {
					_gNotif.notifySuccess('<b>SMS Template</b> - Failed to Create.')
					this.is_loading = false;
				})
			}
		},
	}
}
</script>